import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planMutationKeys, planQueryKeys } from '../constants'
import { planCounterQueryKeys } from '../../plan-counter/constants'
import { customQueryClient } from '../../config/query-client'

export const useUpdateBulkPlansMutation = (options) => {
  const handleMutation = async ({ plans = [] }) => {
    const config = {
      method: 'patch',
      data: plans
    }

    const { data } = await api('/api/plans-api/v3/plans', config)
    return data
  }

  const invalidateRelatedQueries = (projectId) => {
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_INFINITY_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_CHILDREN_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [planCounterQueryKeys.PLAN_COUNTER, projectId]
    })
  }

  return useMutation({
    mutationKey: [planMutationKeys.UPDATE_BULK_PLANS_MUTATION],
    mutationFn: handleMutation,
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateRelatedQueries(variables.projectId)

      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
    }
  })
}
